<template>
    <div class="block-boy">
        <p class="block-boy__text block-boy__text-one">
            Подростку в этом возрасте уже не нужен сопровождающий взрослый, зато пригодятся знания по планированию времени и постановке целей. Для отдыха между учебой нужен свежий воздух и движение. Прогулки по парку едва ли подойдут для этого (скучно!). Но <a href="https://www.pik.ru/les/feature/229?utm_source=pikabu.ru&utm_campaign=general&utm_medium=referral&utm_content=timeline" class="app__link app__link--red" target="_blank">скейт-площадка</a> рядом с домом вполне устроит.
        </p>
        <BlockParallax
            fixed
            speed="10"
            direction="top"
            transform="translateY"
            class="block-boy__img--mobile"
        >
            <div class="block-boy__img-caja">
                <img
                    srcset="../assets/boy-1.jpg, ../assets/boy-1@2x.jpg 2x"
                    src="../assets/boy-1.jpg"
                    class="block-boy__img block-boy__img block-boy__img-one"
                />
                <div class="image-caption image-caption--overlap-right">Скейт-парк в проекте<br>«Лефортово парк»</div>
            </div>
        </BlockParallax>

        <BlockParallax
            class="block-boy__img-box"
            fixed
            speed="8"
            offset="350"
            direction="top"
            transform="translateY"
        >
            <img
                srcset="../assets/boy-2.jpg, ../assets/boy-2@2x.jpg 2x"
                src="../assets/boy-2.jpg"
                class="block-boy__img block-boy__img-two"
            />
            <div class="image-caption">Двор в проекте «Бунинские луга»</div>
        </BlockParallax>
        
        <BlockParallax class="block-boy__icon block-boy__icon--clock block-boy--icon-desktop" speed="8" direction="left">
            <img src="@/assets/images/icons/1517-clock.png">
        </BlockParallax>
        <BlockParallax class="block-boy__icon block-boy__icon--book block-boy--icon-desktop" speed="10" direction="left">
            <img src="@/assets/images/icons/1517-book.png">
        </BlockParallax>
        <BlockParallax class="block-boy__icon block-boy__icon--heart block-boy--icon-desktop" speed="15">
            <img src="@/assets/images/icons/1517-heart-blue.png">
        </BlockParallax>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'
export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
.block-boy {
    display flex
    flex-direction column
    +layout-md-and-up() {
        position relative
        margin-top 5rem
    }
    &__text {
        margin 2rem 0 0 0
        font-size 1.5rem
        line-height 1.47
        letter-spacing 0.16px
        color $color-text
        padding-left 5rem
        +layout-md-and-up() {
            max-width 45rem
            padding-left: 8rem
        }
        +layout-l-and-up() {
            max-width 43.4rem
        }
    }
    &__text-one {
        +layout-md-and-up() {
            order: 1
        }
    }
    &__text-two {
        margin-top 2.6rem
        +layout-md-and-up() {
            order: 2
        }

    }
    &__img {
        &--mobile {
            +layout-xs() {
                text-align right
            }
        }
        +layout-md-and-up() {
            &-caja {
                order 3
                position: absolute
                top: 0
                right: 2rem
                margin-top 0
            }
        }
    }
    &__img-one {
        margin-top 3rem
        width: calc(100% - 1rem)
        margin-right: -2rem
        margin-left: auto
        +layout-sm-and-up() {
            width auto
        }
    }
    &__img-box {
        margin-top 2.5rem
        margin-left -1rem
        margin-right -1rem
        +layout-sm-and-up() {
            width auto
        }
        +layout-md-and-up() {
            order 4
            margin-left 0
            margin-right 0
            max-width 62rem
        }
    }
    &__img-two {
        object-fit cover
        width 100%
        max-width 100%
        +layout-md-and-up() {
            position: relative
            z-index 5
            max-width 62.5rem
            margin-top 3.7rem
        }
    }
    
    &__icon {
        position absolute
        max-width 100%
    }

    &__icon--book {
        +layout-md-and-up() {
            bottom 20rem
            left -8rem
            width 12rem
            img {
                transform rotate(20deg)
            }
        }
    }

    &__icon--heart {
        +layout-md-and-up() {
            bottom 7rem
            right 8rem
            img {
                transform rotate(-120deg)
            }
        }
    }

    &__icon--clock {
        +layout-md-and-up() {
            bottom 15rem
            right -5rem
            width 8rem
            img {
                transform rotate(-120deg)
            }
        }
    }

    &--icon-desktop {
        display none
        +layout-md-and-up() {
            display block
        }
    }
}
.image-caption {
    &--overlap-right {
        padding-left 26%
    }
}
</style>
